import type { EnvironmentId, EnvironmentApi } from "@t3tools/contracts";

import type { WsRpcClient } from "@t3tools/client-runtime";
import { readEnvironmentConnection } from "./environments/runtime";

export function createEnvironmentApi(rpcClient: WsRpcClient): EnvironmentApi {
  return {
    projects: {
      searchEntries: rpcClient.projects.searchEntries,
      documentsStatus: rpcClient.projects.documentsStatus,
      usageReport: rpcClient.projects.usageReport,
      deleteDocument: rpcClient.projects.deleteDocument,
      outputStatus: rpcClient.projects.outputStatus,
      copyOutputToAttachments: rpcClient.projects.copyOutputToAttachments,
      deleteOutputFile: rpcClient.projects.deleteOutputFile,
    },
    orchestration: {
      dispatchCommand: rpcClient.orchestration.dispatchCommand,
      getArchivedShellSnapshot: rpcClient.orchestration.getArchivedShellSnapshot,
      subscribeShell: (callback, options) =>
        rpcClient.orchestration.subscribeShell(callback, options),
      subscribeThread: (input, callback, options) =>
        rpcClient.orchestration.subscribeThread(input, callback, options),
    },
  };
}

export function readEnvironmentApi(environmentId: EnvironmentId): EnvironmentApi | undefined {
  if (typeof window === "undefined") {
    return undefined;
  }

  if (!environmentId) {
    return undefined;
  }

  const connection = readEnvironmentConnection(environmentId);
  return connection ? createEnvironmentApi(connection.client) : undefined;
}

export function ensureEnvironmentApi(environmentId: EnvironmentId): EnvironmentApi {
  const api = readEnvironmentApi(environmentId);
  if (!api) {
    throw new Error(`Environment API not found for environment ${environmentId}`);
  }
  return api;
}
